import t, { Component as e } from "react";
import r from "../../../node_modules/classnames/index.js";
import { registerables as n, Chart as o } from "../../../node_modules/chart.js/dist/chart.esm.js";
function i(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var r = 0, n = Array(e); r < e; r++) n[r] = t[r];
  return n;
}
function a(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function s(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function c(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function u(t) {
  return (u = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function l(t, e) {
  return (l = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var p = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && l(t, e);
  }(d, e);
  var p,
    f,
    h,
    y = (p = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        r = u(d);
      if (p) {
        var n = u(this).constructor;
        e = Reflect.construct(r, arguments, n);
      } else e = r.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : a(this);
    });
  function d() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, d), t = y.apply(this, arguments), c(a(t), "chart", null), c(a(t), "canvas", void 0), c(a(t), "_canvasRef", function (e) {
      return t.canvas = e;
    }), t;
  }
  return f = [{
    key: "initChart",
    value: function value() {
      n && o.register.apply(o, function (t) {
        if (Array.isArray(t)) return i(t);
      }(n) || function (t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }(n) || function (t, e) {
        if (t) {
          if ("string" == typeof t) return i(t, e);
          var r = Object.prototype.toString.call(t).slice(8, -1);
          if ("Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
          if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return i(t, e);
        }
      }(n) || function () {
        throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()), this.chart = new o(this.canvas, {
        type: this.props.type,
        data: this.props.data,
        options: this.props.options
      });
    }
  }, {
    key: "getCanvas",
    value: function value() {
      return this.canvas;
    }
  }, {
    key: "getBase64Image",
    value: function value() {
      return this.chart.toBase64Image();
    }
  }, {
    key: "generateLegend",
    value: function value() {
      this.chart && this.chart.generateLegend();
    }
  }, {
    key: "refresh",
    value: function value() {
      this.chart && this.chart.update();
    }
  }, {
    key: "reinit",
    value: function value() {
      this.chart && (this.chart.destroy(), this.initChart());
    }
  }, {
    key: "shouldComponentUpdate",
    value: function value(t) {
      return t.data !== this.props.data || t.options !== this.props.options || t.type !== this.props.type;
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.initChart();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.reinit();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.chart && (this.chart.destroy(), this.chart = null);
    }
  }, {
    key: "render",
    value: function value() {
      var e = r("kaseya-ui-p-chart", this.props.className),
        n = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {},
              n = Object.keys(r);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (t) {
              return Object.getOwnPropertyDescriptor(r, t).enumerable;
            }))), n.forEach(function (e) {
              c(t, e, r[e]);
            });
          }
          return t;
        }({
          width: this.props.width,
          height: this.props.height
        }, this.props.style);
      return t.createElement("div", {
        id: this.props.id,
        style: n,
        className: e
      }, t.createElement("canvas", {
        ref: this._canvasRef,
        width: this.props.width,
        height: this.props.height
      }));
    }
  }], s(d.prototype, f), h && s(d, h), d;
}(e);
c(p, "displayName", "Chart"), c(p, "defaultProps", {
  id: null,
  type: null,
  data: null,
  options: null,
  width: null,
  height: null,
  style: null,
  className: null
});
export { p as Chart };